import { useState, useEffect } from "react";

// Fetches the tenant's recently-played tracks from the content API.
// Data concern only — rendering lives in <RecentlyPlayed>. Refetches whenever
// `refreshKey` changes (pass the current track id so the list refreshes when
// the song changes) and only runs while `enabled` is true (so an unopened
// popup makes no requests).
//
//   url       — `.../tenants/:tenant/recently-played` (no query string)
//   limit     — max rows to request (server clamps 1..100)
//   refreshKey— change to force a refetch
//   enabled   — skip fetching entirely when false
export function useRecentlyPlayed(url, { limit = 20, refreshKey, enabled = true } = {}) {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !url) return undefined;

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch(`${url}?limit=${limit}`)
      .then((res) => {
        if (!res.ok) throw new Error(`Recently-played fetch failed: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!cancelled) setTracks(Array.isArray(data.tracks) ? data.tracks : []);
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("[useRecentlyPlayed]", err.message);
          setError(err);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [url, limit, refreshKey, enabled]);

  return { tracks, loading, error };
}

export default useRecentlyPlayed;
